import { Button, Container, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { validateAppKey } from '../../helpers/crypto';

interface Props {

}

export default function EnterPassword(props: Props) {
  const [password, setPassword] = React.useState<string>("");
  const [passwordError, setPasswordError] = React.useState<string | undefined>(undefined);

  function checkAuth() {
    const passed = validateAppKey(password)
    if (!passed) {
      setPasswordError("Incorrect password :(");
      return;
    }

    document.cookie = `vegas-expenses-key=${password}`;
    window.location.reload();
  }

  return (
    <Stack direction="column">
      <TextField
        sx={{ flexGrow: 1 }}
        type="text"
        label="Password"
        autoCapitalize='off'
        autoCorrect='off'
        spellCheck='false'
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={!!passwordError}
        helperText={passwordError}
        placeholder="Enter the password 🤫"
        // On enter, submit
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            checkAuth();
          }
        }}
      />
      < Stack direction="row" justifyContent="flex-end" >
        <Button sx={{ mt: 2, width: "100px" }} variant="contained" onClick={checkAuth}>Submit</Button>
      </Stack>
    </Stack >
  );
}
